import { render } from "./PersoneFisiche.vue?vue&type=template&id=d334a47a"
import script from "./PersoneFisiche.vue?vue&type=script&lang=js"
export * from "./PersoneFisiche.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__